<img *ngIf="!globalService.isChatbotOpen && !isDialogOpen" matTooltipPosition="left" class="SmileyHelp45" src="/assets/icons/SmileyHelp45.png?v=1" (click)="SmileyHelp()" (pointerdown)="onDragStart($event)" />

